import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Button, Table, Select, Input, BackTop, Tag } from "antd";

import { usrRole } from "../../utils/dataUtil";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { getGraduateAcademicYear } from "../../utils/dateUtil";
import {
  req_page_gqm_previousclassteacher,
  req_downloadfile_gqm_previousclassteacher,
} from "../../api";

class PreviousClassTeacher extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,

    /*特定參數*/
    searchFieldExtA: getGraduateAcademicYear(new Date()) - 1,
    searchFieldExtB: "NONE", //EducationalSystem
    searchFieldExtC: "NONE", //Division
    searchFieldExtD: "NONE", //TeacherStatus
    searchFieldExtE: "NONE", //ShortDeptName
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, items: [] });

    const result = await req_page_gqm_previousclassteacher(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE
    );
    this.setState({ loading: false });

    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_gqm_previousclassteacher(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "畢業校友清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "YearGrade",
        width: 35,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "部別",
        dataIndex: "Division",
        width: 35,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學制",
        dataIndex: "EducationalSystem",
        width: 35,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "系所",
        dataIndex: "DepartmentName",
        width: 70,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "班級",
        dataIndex: "ClassGradeName",
        width: 40,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "導師",
        dataIndex: "ClassTeacherName",
        width: 45,
        render: (text) => (
          <div className="text-center">
            <span style={{ fontSize: "1.3em" }}> {text}</span>
          </div>
        ),
      },
      {
        title: "狀態",
        dataIndex: "TeacherStatus",
        width: 35,
        render: (text) => {
          return (
            <div className="text-center">
              <Tag
                color={text === "在職" ? "green" : "red"}
                style={{ fontSize: "1.3em" }}
              >
                {text}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "電話",
        dataIndex: "MobilePhone",
        width: 50,
        render: (text) => (
          <div className="text-center">
            <span style={{ fontSize: "1.3em" }}> {text}</span>
          </div>
        ),
      },
      {
        title: "電郵",
        dataIndex: "Email",
        width: 50,
        responsive: ["md"],
        render: (text) => (
          <div className="text-center">
            <span> {text}</span>
          </div>
        ),
      },
    ];
  };
  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        // const { activityNid } = item
        // Modal.confirm({
        //     title: `您確定刪除此筆數據`,
        //     onOk: () => {
        //         this.api_delete_item(activityNid)
        //     }
        // })
        break;
      case "download":
        break;
      default:
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      deviceWidth,
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const title = (
      <span>
        <Input
          placeholder="畢業學年度"
          style={{ width: 80, margin: "0 5px", backgroundColor: "lightyellow" }}
          value={searchFieldExtA}
          onChange={(event) =>
            this.setState({ searchFieldExtA: event.target.value })
          }
        />
        {deviceWidth > 1200 ? (
          <>
            <Select
              value={searchFieldExtC}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtC: value })}
            >
              <Select.Option value="NONE">部別</Select.Option>
              <Select.Option value="日間部">日間部</Select.Option>
              <Select.Option value="進修部">進修部</Select.Option>
              <Select.Option value="在職專班">在職專班</Select.Option>
              <Select.Option value="假日專班">假日專班</Select.Option>
            </Select>
            <Select
              value={searchFieldExtB}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtB: value })}
            >
              <Select.Option value="NONE">學制</Select.Option>
              <Select.Option value="四技">四技</Select.Option>
              <Select.Option value="二技">二技</Select.Option>
              <Select.Option value="七技">七技</Select.Option>
              <Select.Option value="研究所">研究所</Select.Option>
              <Select.Option value="二專">二專</Select.Option>
              <Select.Option value="三專">三專</Select.Option>
              <Select.Option value="五專">五專</Select.Option>
            </Select>
            <Select
              value={searchFieldExtE}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtE: value })}
            >
              <Select.Option value="NONE">學系</Select.Option>
              <Select.Option value="幼保">幼保</Select.Option>
              <Select.Option value="生服">生服</Select.Option>
              <Select.Option value="企管">企管</Select.Option>
              <Select.Option value="多動">多動</Select.Option>
              <Select.Option value="行樂">行樂</Select.Option>
              <Select.Option value="服設">服設</Select.Option>
              <Select.Option value="室設">室設</Select.Option>
              <Select.Option value="美容">美容</Select.Option>
              <Select.Option value="美術">美術</Select.Option>
              <Select.Option value="音樂">音樂</Select.Option>
              <Select.Option value="旅管">旅管</Select.Option>
              <Select.Option value="時尚">時尚</Select.Option>
              <Select.Option value="財金">財金</Select.Option>
              <Select.Option value="商設">商設</Select.Option>
              <Select.Option value="國企">國企</Select.Option>
              <Select.Option value="連鎖">連鎖</Select.Option>
              <Select.Option value="視傳">視傳</Select.Option>
              <Select.Option value="會資">會資</Select.Option>
              <Select.Option value="資管">資管</Select.Option>
              <Select.Option value="運休">運休</Select.Option>
              <Select.Option value="漫畫">漫畫</Select.Option>
              <Select.Option value="舞蹈">舞蹈</Select.Option>
              <Select.Option value="養生">養生</Select.Option>
              <Select.Option value="餐旅">餐旅</Select.Option>
              <Select.Option value="餐飲">餐飲</Select.Option>
              <Select.Option value="應英">應英</Select.Option>
            </Select>
            <Select
              value={searchFieldExtD}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtD: value })}
            >
              <Select.Option value="NONE">在職狀況</Select.Option>
              <Select.Option value="在職">在職</Select.Option>
              <Select.Option value="離職">離職</Select.Option>
            </Select>
          </>
        ) : (
          ""
        )}
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索其他條件</Select.Option>
          <Select.Option value="ClassTeacherCode">導師職號</Select.Option>
          <Select.Option value="ClassTeacherName">導師姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        {deviceWidth > 600 ? (
          <>
            <Button type="primary" onClick={() => this.handle_data_download()}>
              <i className="fas fa-cloud-download-alt element-hidden"></i>
              <span style={{ marginLeft: "4px" }}>下載</span>
            </Button>
          </>
        ) : (
          ""
        )}
      </span>
    );
    return (
      <Card>
        {title}
        <p></p>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey=""
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />

        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(PreviousClassTeacher);
